import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa"; // Make sure you have react-icons installed

export const SolarWindsCard = ({ image, title, description, description1 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={`sw-card ${isExpanded ? "expanded" : ""}`}>
      <div className="sw-card-header" onClick={toggleExpand}>
        <div className="sw-card-icon-container">
          <img src={image} alt={title} className="sw-card-icon" />
        </div>
        <h3 className="sw-card-title">{title}</h3>
        <button className="sw-expand-btn" aria-label={isExpanded ? "Collapse" : "Expand"}>
          {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
        </button>
      </div>
      
      <div className="sw-card-body">
        <p className="sw-card-description">{description}</p>
        {description1 && (
          <div className={`sw-card-details ${isExpanded ? "show" : ""}`}>
            <p>{description1}</p>
          </div>
        )}
      </div>
      {!isExpanded && description1 && (
        <div className="sw-read-more" onClick={toggleExpand}>
            Read More
        </div>
      )}
    </div>
  );
};